/**
 *
 * @param $stateProvider
 */
export function AuthRouter($stateProvider) {
	"ngInject";

	$stateProvider
		.state({
			name: "auth",
			template: "<auth></auth>"
		})
		.state({
			name: "auth.signin",
			url: "/app/signin",
			template: "<signin></signin>",
			resolve: {
				$title: () => "Sign in | UpReach Cloud"
			}
		})
        .state({
			name: "auth.acceptInvite",
			url: "/app/accept-invite/:token/",
			template: "<accept-invite></accept-invite>",
			resolve: {
				$title: () => "Accept invite | UpReach Cloud"
			}
		})
		.state({
			name: "auth.password",
			url: "/app/password/",
			template: "<password></password>",
			resolve: {
				$title: () => "Reset password | UpReach Cloud"
			}
		})
		.state({
            name: "auth.resetPassword",
            url: "/app/password-set/:token/",
            template: "<reset-password></reset-password>",
			resolve: {
				$title: () => "Confirm password | UpReach Cloud"
			}
		})
		.state({
			name: "auth.twoFactor",
			url: "/app/two-factor/",
			template: "<two-factor></two-factor>",
			resolve: {
				$title: () => "Two-Factor Authentication | UpReach Cloud"
			}
		})
		.state({
			name: "auth.twoFactorSuccess",
			url: "/app/two-factor-success/",
			template: "<two-factor-success></two-factor-success>",
			resolve: {
				$title: () => "Two-Factor Enabled | UpReach Cloud"
			}
		});
}



// WEBPACK FOOTER //
// ./sources/components/auth/auth.router.js